export default {"src":"/_next/static/media/logo-purple.10ce5f5f.svg","height":598,"width":838,"blurWidth":0,"blurHeight":0};